import React, { useState, useEffect, useRef } from 'react';
import 'bootstrap/dist/css/bootstrap.min.css';
import { Button, Col, Row, Form, Stack, Container } from 'react-bootstrap';
import { useNavigate } from 'react-router-dom';
import { auth } from '../config/Config';
import { useDispatch } from 'react-redux';
import { fetchUserList } from '../redux/userReducer';
import { fetchKitchenThingsList } from '../redux/kitchenThingsReducer';
import { fetchLooseThingsList } from '../redux/looseFurnitureReducer';
import { fetchOtherWorksList } from '../redux/otherWorkReducer';
import { fetchBedroomList } from '../redux/bedroomReducer';
import { fetchFoyerThingsList } from '../redux/foyerReducer';
import { fetchLivingThingsList } from '../redux/livingRoomReducer';
import { fetchAccessoriesList } from '../redux/accessoriesReducer';
import './Login.css';

// ✅ Single helper — dispatches ALL location-dependent data at once
// const dispatchAllRoomData = (dispatch, location) => {
//   const args = { location };
//   dispatch(fetchKitchenThingsList(args));
//   dispatch(fetchLooseThingsList(args));
//   dispatch(fetchOtherWorksList(args));
//   dispatch(fetchBedroomList(args));
//   dispatch(fetchFoyerThingsList(args));
//   dispatch(fetchLivingThingsList(args));
//   dispatch(fetchAccessoriesList(args));
// };

function Login() {
  const navigate = useNavigate();
  const dispatch = useDispatch();

  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [message, setMessage] = useState('');
  const [isLoading, setIsLoading] = useState(false);

  const cursorBallRef = useRef(null);
  const Swal = require('sweetalert2');

  const fetchAndSaveUserDetails = async (uid) => {
    try {
      const response = await fetch(
        `https://us-central1-fabdiz-quote.cloudfunctions.net/api/users/${uid}`
      );
      if (!response.ok) throw new Error('Failed to fetch user details');
      const userDetails = await response.json();
      window.localStorage.setItem('userDetails', JSON.stringify(userDetails));
      window.localStorage.setItem('userLocation', userDetails.location ?? 'BLR');
      return userDetails;
    } catch (err) {
      console.error('Failed to fetch user details on login:', err);
      return null;
    }
  };

  const handleLogin = async (e) => {
    e.preventDefault();
    setIsLoading(true);

    try {
      const userCredential = await auth.signInWithEmailAndPassword(email, password);
      const uid = userCredential.user.uid;

      // Save auth tokens
      const accessToken = await userCredential.user.getIdToken();
      window.localStorage.setItem('userUID', uid);
      window.localStorage.setItem('userToken', accessToken);
      window.localStorage.setItem('userAuth', 'true');
      localStorage.setItem('activeSidebarLink', 'DASHBOARD');

      // ✅ Fetch user details to get location
      const userDetails = await fetchAndSaveUserDetails(uid);
      const location = userDetails?.location ?? 'BLR';

      // ✅ Dispatch user list
      dispatch(fetchUserList(uid));

      // ✅ Dispatch ALL room data with location
      // dispatchAllRoomData(dispatch, location);

      setEmail('');
      setPassword('');
      setMessage('');

      Swal.fire({
        position: 'center',
        icon: 'success',
        title: 'Login Successful!',
        showConfirmButton: false,
        timer: 1500,
      }).then(() => {
        navigate('/', { replace: true });
      });

    } catch (err) {
      Swal.fire({
        position: 'center',
        icon: 'error',
        title: 'Login Failed!',
        text: 'Invalid email or password.',
        showConfirmButton: true,
      });
      setMessage(err.message);
    } finally {
      setIsLoading(false);
    }
  };

  useEffect(() => {
    const moveCursorBall = (e) => {
      const ball = cursorBallRef.current;
      if (ball) {
        ball.style.transform = `translate(${e.clientX}px, ${e.clientY}px)`;
      }
    };
    document.addEventListener('mousemove', moveCursorBall);
    return () => document.removeEventListener('mousemove', moveCursorBall);
  }, []);

  return (
    <>
      <div ref={cursorBallRef} className="cursor-ball"></div>
      <Container fluid>
        <Row className="login-container4">
          <Col sm={3} className="login-sidebar4">
            <Stack className="logo-container4">
              <img src={require('../assests/sitelogo.png')} alt="Dashboard" className="logo4" />
            </Stack>
          </Col>

          <Col sm={9} className="login-form-container4">
            <p data-testid="login-Header" className="login-title4">
              Already have an account?{' '}
              <span className="login-title-bold4">Sign In</span>
            </p>

            <Form className="form-group" autoComplete="off" onSubmit={handleLogin}>
              <Form.Group className="mb-3" controlId="formBasicEmail">
                <Form.Label className="form-label4">Email ID</Form.Label>
                <Form.Control
                  onChange={(e) => setEmail(e.target.value)}
                  value={email}
                  type="email"
                  placeholder="Enter email"
                  className="form-control4"
                  disabled={isLoading}
                />
              </Form.Group>

              <Form.Group className="mb-3" controlId="formBasicPassword">
                <Form.Label className="form-label4">Enter password</Form.Label>
                <Form.Control
                  onChange={(e) => setPassword(e.target.value)}
                  value={password}
                  type="password"
                  placeholder="Password"
                  className="form-control4"
                  disabled={isLoading}
                />
              </Form.Group>

              <Form.Group className="mb-3">
                <Form.Text className="forgot-password4">Forgot password?</Form.Text>
              </Form.Group>

              <Form.Group className="mb-3">
                <Form.Label className="error-message">{message}</Form.Label>
                <Button
                  variant="primary"
                  type="submit"
                  className="submit-btn4"
                  disabled={isLoading}
                >
                  {isLoading ? 'Signing In...' : 'Sign In'}
                </Button>
              </Form.Group>
            </Form>
          </Col>
        </Row>
      </Container>
    </>
  );
}

export default Login;